import React from "react"
import { requestIdleCallback, isSSR, isHydrating, isBrowser, useLocalStorage, Modal } from "lib"
import Logo from "../header/Logo"

const text = {
  en: {
    c_title: 'Cookie Consent',
    c_text: 'We use cookies to collect information about you. We use this information to give you a better experience of our website (functional), to count the pages you visit (statistics), to serve you relevant promotions (marketing). Click "OK" to give us your consent to use cookies for all these purposes. You can also use the checkboxes to consent to specific purposes. Select purposes and "Save settings".',
    c_cancel: 'Decline all',
    c_details: 'Show details',
    c_ok: 'OK',

    c_title2: 'Cookie Consent',
    c_ad_storage: 'Enable storage (such as cookies) related to advertising.',
    c_ad_user_data: 'Sets consent for sending user data related to advertising to Google. The ad_user_data consent type is required for measurement use cases, such as enhanced conversions and tag-based conversion tracking.',
    c_ad_personalization: 'Sets consent for personalized advertising.',
    c_analytics_storage: 'Enable storage (such as cookies) related to analytics e.g. visit duration.',
    c_save: 'Save settings'
  },
  ro: {
    c_title: 'Protecția datelor cu caracter personal',
    c_text: 'Acest site aplică noua politică de protecție a datelor cu caracter personal și modificările propuse de Regulamentul (UE) 2016/679. Te rugăm să confirmi acceptarea utilizării fişierelor de tip cookie conform Politicii de Cookie.',
    c_cancel: 'Refuz',
    c_details: 'Arată Detalii',
    c_ok: 'Accept cookie-uri',

    c_title2: 'Consimțământ',
    c_ad_storage: 'Permite stocarea, cum ar fi cookie-uri (web) sau identificatori de dispozitiv (aplicații), legate de publicitate.',
    c_ad_user_data: 'Setează consimțământul pentru trimiterea datelor utilizatorilor către Google în scopuri publicitare online.',
    c_ad_personalization: 'Setează consimțământul pentru publicitatea personalizată.',
    c_analytics_storage: 'Permite stocarea, cum ar fi cookie-uri (web) sau identificatori de dispozitiv (aplicații), legate de analize, de exemplu, durata vizitei.',
    c_save: 'Salvează'
  }
}


//How your data is used by Google
//Choose how Google can collect and use your data for a better browsing experience on our site. Your privacy is paramount, and you have full control here.
//Allow Google Analytics to measure how I use the site to enhance functionality and service.
//Permit Google to save advertising information on my device for better ad relevance.
//<p class="ListSwitch__Vendor__Description">Share my activity data with Google for targeted advertising.</p>
//<p class="ListSwitch__Vendor__Description">Customize my ad experience by allowing Google to personalize the ads I see.</p>
const default_consent = undefined
//{ 'ad_storage': 'denied', 'ad_user_data': 'denied', 'ad_personalization': 'denied', 'analytics_storage': 'denied'}
const Consent = ({language}) => {
    const [consentv2, setConsent] = useLocalStorage(
        "consent",
        default_consent
    )

    const [hide, setHide] = React.useState(isSSR || (isBrowser && isHydrating()))

    const [state, setState] = React.useState("init")
    const handleOK = React.useCallback(() => {
        const cv2 = {
          'ad_user_data': 'granted',
          'ad_personalization': 'granted',
          'ad_storage': 'granted',
          'analytics_storage': 'granted'
        }
        setConsent(cv2)
        window.gtag('consent', 'update', cv2)
        setState("close")
    }, [setConsent])
    const handleCancel = React.useCallback(() => {
        const cv2 = {
           'ad_storage': 'denied',
           'ad_user_data': 'denied',
           'ad_personalization': 'denied',
           'analytics_storage': 'denied'
        }
        setConsent(cv2)
        window.gtag('consent', 'update', cv2)
        setState("close")
    }, [setConsent])
    const handleChoose = React.useCallback(() => {
        setState("open")
    }, [])
    const handleSave = React.useCallback(() => {
        const cv2 = {
           'ad_storage': document.getElementById('cv2_ad_storage').checked ? 'granted' : 'denied',
           'ad_user_data': document.getElementById('cv2_ad_user_data').checked ? 'granted' : 'denied',
           'ad_personalization': document.getElementById('cv2_ad_personalization').checked ? 'granted' : 'denied',
           'analytics_storage': document.getElementById('cv2_analytics_storage').checked ? 'granted' : 'denied'
        }
        setConsent(cv2)
        window.gtag('consent', 'update', cv2)
        setState("close")
    }, [setConsent])
    const handleClose = React.useCallback(() => {
        setState("init")
    }, [])

    React.useEffect(() => {
        if (!hide) return
        requestIdleCallback(() => {
            setHide(false)
        })
    }, [hide])
    const open = state === "open"
    //console.log(consentv2)
    if (hide || consentv2) return null

    return (
        <div>

        <Modal
                open={open}
                className="consent-container lightbox-container"
                onClose={handleClose}
                showCloseButton={true}
            >
                <div id="consent-form">
                    <div className="info">
                        <div className="logo">
                            <Logo />
                        </div>
                    </div>
                    <div className="form">
                        <h3>{text[language].c_title}</h3>
                        <div>
                          <input type="checkbox" id="cv2_ad_storage" value="1"/> {text[language].c_ad_storage}
                        </div>
                        <div>
                          <input type="checkbox" id="cv2_ad_user_data" value="1"/> {text[language].c_ad_user_data}
                        </div>
                        <div>
                          <input type="checkbox" id="cv2_ad_personalization" value="1"/> {text[language].c_ad_personalization}
                        </div>
                        <div>
                          <input type="checkbox" id="cv2_analytics_storage" value="1"/> {text[language].c_analytics_storage}
                        </div>

                         <button className="consent" onClick={handleSave}>
                             {text[language].c_save}
                         </button>
                    </div>
                </div>
            </Modal>

        <div id="consent-message">
          <h3>{text[language].c_title}</h3>
          <p>{text[language].c_text}</p>

          <button className="consent" onClick={handleCancel}>
                    {text[language].c_cancel}
          </button>
          <button className="consent" onClick={handleChoose}>
                    {text[language].c_details}
          </button>
          <button className="consent" onClick={handleOK}>
                    {text[language].c_ok}
          </button>
        </div>

        </div>
    )
}
export default React.memo(Consent)
